module.exports = __webpack_public_path__ + "img/device.2bd6cdc1.png";